export default [
  {
    path: 'monitoring',
    name: 'monitoring',
    component: () => import('@/views/pages/monitoring/Monitoring.vue'),
    meta: {
      pageTitle: 'Monitoring',
      breadcrumb: [
        {
          text: 'Monitoring',
          active: true,
        },
      ],
      resource: 'Monitoring',
    },
  },
  {
    path: 'monitoring-report',
    name: 'monitoring-report',
    component: () => import('@/views/pages/monitoring-report/MonitoringReportDoc.vue'),
    meta: {
      pageTitle: 'Monitoring Report',
      breadcrumb: [
        {
          to: { name: 'monitoring' },
          text: 'Monitoring',
          active: false,
        },
        {
          text: 'Monitoring Report',
          active: true,
        },
      ],
      resource: 'MonitoringReportDoctorate',
    },
  },
  {
    path: 'monitoring-report-inno',
    name: 'monitoring-report-inno',
    component: () => import('@/views/pages/monitoring-report/MonitoringReportInno.vue'),
    meta: {
      pageTitle: 'Monitoring Report',
      breadcrumb: [
        {
          text: 'Monitoring Report',
          active: true,
        },
      ],
      resource: 'MonitoringReportInnovation',
    },
  },
  {
    path: 'monitoring-report-otm',
    name: 'monitoring-report-otm',
    component: () => import('@/views/pages/monitoring-report/MonitoringReportOtm.vue'),
    meta: {
      pageTitle: 'Monitoring Report',
      breadcrumb: [
        {
          text: 'Monitoring Report',
          active: true,
        },
      ],
      resource: 'MonitoringReportOtmItm',
    },
  },
  {
    path: 'monitoring-report-advisor',
    name: 'monitoring-report-advisor',
    component: () => import('@/views/pages/monitoring-report/MonitoringReportAdvisor.vue'),
    meta: {
      pageTitle: 'Monitoring Report Advisor',
      breadcrumb: [
        {
          text: 'Monitoring Report Advisor',
          active: true,
        },
      ],
      resource: 'MonitoringReportAdvisor',
    },
  },
  {
    path: 'check-monitoring-inno',
    name: 'check-monitoring-inno',
    component: () => import('@/views/pages/check-monitoring-inno/CheckMonitoring.vue'),
    meta: {
      pageTitle: 'Monitoring',
      breadcrumb: [
        {
          text: 'Monitoring',
          active: true,
        },
      ],
      resource: 'MonitoringReportInnovation',
    },
  },
]
